module.exports = __webpack_public_path__ + "static/media/logo.534212d1.png";